import React from 'react';
import { Badge, Btn, Input } from '../ForBrands/ui/BrandUI';
import { Icon } from '../ForBrands/ui/icons';

// Small pieces the two Codes cards share: the card heading, the add row and
// the round icon buttons on each row (the V2 Users table row action style).

const cx = (...parts) => parts.filter(Boolean).join(' ');

export const IconButton = ({ icon, label, onClick, danger = false }) => (
  <button
    type="button"
    aria-label={label}
    title={label}
    onClick={onClick}
    className={cx(
      'inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-bm-muted transition-colors hover:bg-bm-mutedbg',
      danger ? 'hover:text-bm-critical' : 'hover:text-bm-ink',
    )}
  >
    <Icon name={icon} />
  </button>
);

export const CardHead = ({ title, count, children }) => (
  <div className="flex flex-col gap-1">
    <div className="flex items-center gap-2">
      <h2 className="min-w-0 truncate bm-h-s text-bm-ink">{title}</h2>
      {typeof count === 'number' && <Badge tone="soft">{count}</Badge>}
    </div>
    {children && <p className="bm-body-s text-bm-muted">{children}</p>}
  </div>
);

// Enter in the field adds, like the button.
export const AddRow = ({ value, onChange, onAdd, placeholder, buttonLabel }) => (
  <form
    className="flex min-w-0 gap-2"
    onSubmit={(e) => {
      e.preventDefault();
      onAdd();
    }}
  >
    <Input
      aria-label={placeholder}
      placeholder={placeholder}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className="min-w-0 flex-1"
    />
    <Btn type="submit" disabled={!value.trim()}>
      <Icon name="plus" className="mr-1.5" />
      {buttonLabel}
    </Btn>
  </form>
);
